import { roles } from "./constants";

//Configuration brute des hacks
/**
 * Idées
 * removeSectorLimitationToTerrainClientIds: [1, 2, 3]
 * removeSectorLimitation: [{client_id:1, role_id:4}, {email:'thomas@upsell.fr'}]
 * (ou logique avec tests dynamique, ici pour le dossier ASAHI role terrain, ou l'utilisateur thomas@upsell.fr)
 */
const hacksConfigs = {
  gallery: {
    //retire la limitation du secteur dans la gallerie photo pour les terrains
    removeSectorLimitationToTerrainClientIds: [2], //[1, 17]
    selfContentOnlyToTerrainClientIds: [17] //[1, 17]
  },
  visits: {
    //retire la limitation du secteur dans la gallerie photo pour les terrains
    removeSectorLimitationToTerrainClientIds: [],
    selfContentOnlyToTerrainClientIds: [17]
  }
};

//V0 BETA mode expérimental
/**
 * A placer dans le state quand on sélectionne un dossier (ou le premier par défaut au moment de l'auth)
 * Avantages : définition des hacks à un seul moment, évite de passer userInfos, clientId, roleId ... à chaque fois
 * Inconvénient : Impossible de changer de clientId sans regénérer un objet hacks
 *
 * Idées en vrac
 * Autre version 1 : passer les paramètres dans chaque noeud
 * Autre version 2: séparer les listes et le traitement pour avoir 2 objets : 1 avec le traitement et un avec uniquement les listes
 *
 * @param userInfos
 * @param clientId
 * @param roleId
 * @returns {}
 */
const hacks = (userInfos, clientId, roleId) => {
  roleId = roleId || userInfos.role_id;
  return {
    gallery: {
      //retire la limitation du secteur dans la gallerie photo pour les terrains
      removeSectorLimitationToTerrain: hacksConfigs.gallery.removeSectorLimitationToTerrainClientIds.includes(clientId),
      //affiche seulement les médias de l'utilisateur
      selfContentOnlyToTerrain: hacksConfigs.gallery.selfContentOnlyToTerrainClientIds.includes(clientId)
    },
    visits: {
      //retire la limitation du secteur dans la liste des visites  pour les terrains
      removeSectorLimitationToTerrain: hacksConfigs.visits.removeSectorLimitationToTerrainClientIds.includes(clientId),
      //affiche seulement les visites de l'utilisateur
      selfContentOnlyToTerrain: hacksConfigs.visits.selfContentOnlyToTerrainClientIds.includes(clientId)
    }
  };
};

export default hacks;



// WEBPACK FOOTER //
// src/configs/hacks.js